
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cSifk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dffca75dcb4bb7bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $dffca75dcb4bb7bf$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "A\xf1adir reacci\xf3n",
    'fabric.reactions.error.unexpected': "Las reacciones no est\xe1n disponibles temporalmente",
    'fabric.reactions.loading': 'Cargando...',
    'fabric.reactions.more.emojis': "M\xe1s emojis",
    'fabric.reactions.other.reacted.users': "{count, plural, one {y 1 m\xe1s} other {y {count} m\xe1s}}",
    'fabric.reactions.reactwithemoji': 'Reaccionar con el emoticono {emoji}',
    'fabric.reactions.summary': 'Ver todas las reacciones de los usuarios',
    'reaction-picker-trigger.add.reaction.message': "A\xf1ade una reacci\xf3n",
    'reactions.dialog.close': 'Cerrar',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Desplazarse hacia la izquierda',
    'reactions.dialog.reactions.count': "{count, plural, one {{count,number} reacci\xf3n total} other {{count,number} reacciones totales}}",
    'reactions.dialog.right.navigate': 'Desplazarse hacia la derecha',
    'reactions.dialog.viewall': 'Ver todo',
    'reactions.dialog.viewall.tooltip': 'Ver todas las reacciones de los usuarios'
};

});


//# sourceMappingURL=es.95511f4d.js.map
